const mounted = new WeakSet();
const positionedHosts = new WeakSet();

// Enterprise's native positioner measures the pre-open scale and uses image
// width as a viewport coordinate. Keep its interaction/focus lifecycle, but
// measure and clamp the full-size card on these opt-in scenes only.
export function positionActiveCard(host) {
  const card = host.activeCard;
  if (!card) return;
  const margin = 20;
  const viewportWidth = document.documentElement.clientWidth;
  const viewportHeight = document.documentElement.clientHeight;
  card.style.left = '50%';
  card.style.top = 'calc(100% + 12px)';
  card.style.bottom = 'auto';
  card.style.maxHeight = `${Math.max(1, viewportHeight - margin * 2)}px`;
  const rect = card.getBoundingClientRect();
  const left = Math.min(Math.max(rect.left, margin), viewportWidth - margin - rect.width);
  let top = rect.top;
  if (rect.bottom > viewportHeight - margin) {
    top = card.parentElement.getBoundingClientRect().top - 12 - rect.height;
  }
  top = Math.min(Math.max(top, margin), viewportHeight - margin - rect.height);
  card.style.left = `calc(50% + ${left - rect.left}px)`;
  card.style.top = `calc(100% + 12px + ${top - rect.top}px)`;
}

export function mountHotspotPositioning(scene) {
  const host = scene.closest('hotspots-image.ptt-shoppable-host');
  if (!host || positionedHosts.has(host) || typeof host.checkCardPosition !== 'function') return;
  positionedHosts.add(host);
  host.checkCardPosition = () => positionActiveCard(host);
}

export function refreshScene(scene) {
  const width = scene.getBoundingClientRect().width;
  if (!width) return;
  const composition = width < 600 ? 'mobile' : width < 900 ? 'compact' : 'desktop';
  scene.dataset.pttComposition = composition;
  scene.querySelectorAll('[data-ptt-environment]').forEach((source) => {
    source.media = source.dataset.pttEnvironment === composition ? 'all' : 'not all';
    source.sizes = `${Math.ceil(width)}px`;
  });
  const background = scene.querySelector('.ptt-shoppable-environment__image');
  if (background) background.sizes = `${Math.ceil(width)}px`;
  scene.querySelectorAll('.ptt-shoppable-product__image').forEach((image) => {
    image.sizes = `${Math.ceil(image.parentElement.getBoundingClientRect().width)}px`;
  });
}

export function mountScenes(scope = document) {
  const scenes = [...scope.querySelectorAll('[data-ptt-shoppable-scene]')];
  if (scope.matches?.('[data-ptt-shoppable-scene]')) scenes.unshift(scope);
  scenes.forEach((scene) => {
    if (mounted.has(scene)) return;
    mounted.add(scene);
    const observer = new ResizeObserver(() => refreshScene(scene));
    refreshScene(scene);
    observer.observe(scene);
    customElements.whenDefined('hotspots-image').then(() => {
      if (scene.isConnected) mountHotspotPositioning(scene);
    });
    scene.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
  });
}

mountScenes();
document.addEventListener('shopify:section:load', (event) => mountScenes(event.target));
